import { forwardRef } from 'react';
import { useHasNewTasksQuery } from '@frontend/api-task-center';
import { ActionBar } from '@frontend/action-bar';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { taskCenterTrackingIds } from '@frontend/task-center-components';
import { useGetTaskCenterCustomizationFlagValue, useTaskCenterStore } from '@frontend/task-center-scope';
import { TopBarFocusIds } from '../../utils/focus-registry';

export const TaskCenterButton = forwardRef<HTMLButtonElement>((props, ref) => {
  const { t } = useTranslation('task-center');

  const { selectedLocationIds } = useAppScopeStore();

  const { isTaskCenterOpen, setIsTaskCenterOpen } = useTaskCenterStore(['isTaskCenterOpen', 'setIsTaskCenterOpen']);

  const { isTaskCenterEnabled } = useGetTaskCenterCustomizationFlagValue();

  const { data } = useHasNewTasksQuery({
    request: { locationId: selectedLocationIds },
    options: { enabled: isTaskCenterEnabled },
  });

  const hasDot = data?.hasNewTasks ?? false;

  return (
    <ActionBar.Action
      label={t('Task Center')}
      id={TopBarFocusIds.taskCenter}
      icon='mark-done'
      isActive={isTaskCenterOpen}
      onClick={() => setIsTaskCenterOpen(!isTaskCenterOpen)}
      trackingId={taskCenterTrackingIds.topBarButton}
      hasDot={hasDot}
      ref={ref}
      {...props}
    />
  );
});
TaskCenterButton.displayName = 'TaskCenterButton';
